var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-dropdown',{staticClass:"m-l-15",attrs:{"right":"","variant":"primary","text":_vm.text_dropdown}},[_c('b-dropdown-item',{on:{"click":_vm.setUpdate}},[_c('i',{staticClass:"icon-undo"}),_vm._v(" Actualizar ")]),_c('b-dropdown-item',{on:{"click":_vm.setDelete}},[_c('i',{staticClass:"icon-trash"}),_vm._v(" Eliminar ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }